import React from 'react';
import { Link } from 'react-router';
import styled, {css} from 'styled-components';
import { motion } from 'framer-motion';
const BtnVolverAnim = ( {Ref}) => {
    return ( 
        <BtnVolverContainer
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        >
        <Link to={Ref}>&larr;Volver </Link>
        </BtnVolverContainer>
     );
}
const BtnVolverContainer = styled(motion.div)`
  min-width: 90%;
  max-width: 90%;
  margin: 5px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    padding: 10px 40px;
    width: 100%;
    text-align: center;
   }
`;

export default BtnVolverAnim;